/**
 * @generated SignedSource<<133ec002f0107a805904083f1d68a96d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type WidgetIssueOverviewHighlightedQuery$variables = {};
export type WidgetIssueOverviewHighlightedQuery$data = {
  readonly store: {
    readonly activeIssueId: string | null;
  };
};
export type WidgetIssueOverviewHighlightedQuery = {
  response: WidgetIssueOverviewHighlightedQuery$data;
  variables: WidgetIssueOverviewHighlightedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeIssueId",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetIssueOverviewHighlightedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WidgetIssueOverviewHighlightedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d83129a29b83c34c6a0c5327038d1763",
    "id": null,
    "metadata": {},
    "name": "WidgetIssueOverviewHighlightedQuery",
    "operationKind": "query",
    "text": "query WidgetIssueOverviewHighlightedQuery {\n  store {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f692fbdd07046dbb1880bd1cce665d28";

export default node;
